import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLazyGetCoCustomerTimeSeriesQuery } from 'src/services';
import { useLoader } from 'src/provider/LoaderProvider';
import { useAppSelector } from 'src/store';
import { TotalProcessedBarChart } from 'src/pages/AnalyticsPage/AnalyticsCustomer/TotalProcessedBarChart/TotalProcessedBarChart';
import { API_VERSION } from 'src/constants/api-routes';

export const WeeklyAnalyticsChart = ({
  dataKey = '',
  dateRange,
  dataKeyStack = '',
  hideLabel = false,
  chartType = undefined,
  className = undefined,
}: {
  dataKey?: string;
  dateRange?: any;
  dataKeyStack?: string;
  hideLabel?: boolean;
  chartType?: string;
  className?: string;
}) => {
  const { id } = useParams();
  const loader = useLoader();
  const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
  const isV1 = version === API_VERSION.V1;
  const { timezone } = useAppSelector((s) => s.analyticSlices);
  const [timeSeriesRequest, setTimeSeriesRequest] = useState({
    project_ids: [id],
    start_time: dateRange?.start_time,
    end_time: dateRange?.end_time,
    group_by: 'day',
    tz_offset: timezone.offset * 60,
  });
  const [timeSeriesResponse, setTimeSeriesResponse] = useState([]);
  const [fetchTimeSeriesQuery, { data: timeSeriesData, isFetching, isError, error }] =
    useLazyGetCoCustomerTimeSeriesQuery() as any;

  useEffect(() => {
    if (isFetching) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isFetching]);

  useEffect(() => {
    if (isError) {
      error.status === 404 && setTimeSeriesResponse([]);
    }
  }, [isError]);

  useEffect(() => {
    if (!dateRange) {
      return;
    }
    setTimeSeriesRequest({
      ...timeSeriesRequest,
      project_ids: [id],
      start_time: dateRange?.start_time,
      end_time: dateRange?.end_time,
      group_by: 'day',
      tz_offset: timezone.offset * 60,
    });
  }, [id, dateRange?.start_time, dateRange?.start_time, timezone]);

  useEffect(() => {
    if (isV1 && timeSeriesRequest && timeSeriesRequest.end_time && timeSeriesRequest.start_time) {
      fetchTimeSeriesQuery(timeSeriesRequest);
    }
  }, [timeSeriesRequest]);

  useEffect(() => {
    if (timeSeriesData && timeSeriesData.length) {
      setTimeSeriesResponse(timeSeriesData);
    } else {
      setTimeSeriesResponse([]);
    }
  }, [timeSeriesData]);

  return (
    <div className="w-full">
      {timeSeriesResponse.length ? (
        <div className={'w-full h-full'}>
          <TotalProcessedBarChart
            hideLabel={hideLabel}
            data={timeSeriesResponse}
            dataKey={dataKey}
            dataKeyStack={dataKeyStack}
            groupBy={timeSeriesRequest.group_by}
            minHeight="260px"
            height={260}
          />
        </div>
      ) : (
        <div
          className={
            'w-full h-[260px] flex items-center justify-center font-medium text-[#7A6BE5] text-xs'
          }
        >
          No data available for this week.
        </div>
      )}
    </div>
  );
};
